import { FC, ReactNode } from "react";
import styled from "styled-components";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";

const TextareaAutosize = dynamic(() => import("react-textarea-autosize"), { ssr: false });

const ChatFooterMessageInput = (): ReactNode => {
  const { t } = useTranslation();
  return <StyledTextarea minRows={1} maxRows={5} placeholder={t("chatWidget.inputPlaceholder")} spellCheck={false} />;
};

const StyledTextarea = styled(TextareaAutosize)`
  flex: auto;
  min-height: 80px;
  color: #111113 !important;
  font-size: 15px;
  line-height: 24px;
  padding-right: 12px;
  border: none;
  outline: none;
  box-shadow: none;
  overflow: auto;
  resize: none;
  padding-top: 29px;
  padding-bottom: 12px;

  &::-webkit-scrollbar {
    display: none;
  }

  &::placeholder {
    color: #6b7385 !important;
    opacity: 1;
  }
`;

export default ChatFooterMessageInput;
